import { type Application } from 'src/types/application'

import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

interface UpdateApplicationPayload {
  appId: string
  displayName: string
  permissions: string[]
}

const useUpdateApplicationMutation = () => {
  const account = useAccount()

  return useMutation(
    async (payload: UpdateApplicationPayload) => {
      const response = await api.put(`graph/account/${account.id}/application/${payload.appId}`, payload)
      return response.data as Application
    },
    {
      queryKeysToInvalidate: [['applications', account.id]],
      successMessage: 'Application updated successfully.',
      errorMessage: 'We were unable to update your application. If the problem persists, please contact support.'
    }
  )
}

export default useUpdateApplicationMutation
